import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-dropdown',
   templateUrl: './dropdown.component.html',
   styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit, AfterViewInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: string;
   @Input() labelName: any;
   @Input() choices: any;
   @Input() classes: any;
   @Input() hideHeader: boolean = false;
   choiceDefaultValue: string;
   options = [];
   value: any;

   constructor(private eformService: EformService, private cdr: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      if (!this.value && !this.field.choices) {
         if (this.field.radioDefaultValue && this.field.radioDefaultValue !== '') {
            this.value = this.field.choiceDefaultValue;
         }
      }
      if (this.field.choiceOption === 0) {
         this.choiceDefaultValue = (this.field.choiceDefaultValue !== '-1') ? this.field.choiceDefaultValue.toString() : '';
      } else {
         this.choiceDefaultValue = (this.field.tempLookupDefault) ? this.field.tempLookupDefault.toString() : '';
      }

      const index = this.findIndexChar(this.classes);
      for (let i = 0; i < this.choices.length; i++) {
         if (this.choices[i].label.length > index) {
            this.options.push({label: this.choices[i].label.substring(0, index) + '...', value: this.choices[i].value});
         } else {
            this.options.push({label: this.choices[i].label, value: this.choices[i].value});
         }
      }
      this.cdr.detectChanges();
   }

   findIndexChar(classes: any) {
      let index = 0;
      switch (classes) {
         case 'field-one' :
            index = 110;
            break;
         case 'field-two' :
            index = 50;
            break;
         case 'field-three' :
            index = 35;
            break;
      }
      return index;
   }

   ngAfterViewInit(): void {
      if (this.field.fieldType === 't-radio') {
         if (this.field.radioDefaultValue !== undefined && !this.value) {
            this.value = this.field.radioDefaultValue;
            this.form.get(this.fieldName).setValue((this.value));
         }
      } else if (this.value) {
         this.form.get(this.fieldName).setValue((this.value));
      } else {
         this.form.get(this.fieldName).setValue(this.choiceDefaultValue);
      }


      if (this.isEmpty(this.form.get(this.fieldName).value)) {
         if (this.form.get(this.fieldName)?.hasValidator(Validators.required)) {
            this.form.get(this.fieldName)?.setValue('')
            this.form.get(this.fieldName)?.setErrors({invalid: true})
            this.form.get(this.fieldName)?.updateValueAndValidity();
         }
      }
      this.cdr.detectChanges();
   }

   isEmpty(value: any): boolean {
      return value == null || value === '' || value === '-1' || value === -1;
   }
}
